import { defaultPollResultCard } from './defaultShapes/poll-result';
import { generateFactory } from './generate-factory';
import { generatePollResultCardId } from './generate-ids';

export const generatePollResult = generateFactory(
    defaultPollResultCard,
    generatePollResultCardId
);
